export default {
    path : "enterprise-account",
    name : "enterprise-account",
    meta : {
        title : "全部企业"
    },
    component: () => import('@/components/router/Router'),

    redirect: {
        name : "enterprise-account-whole"
    },
    children:[
        {
            path: '',
            name: '',
            meta: {
                title: ''
            },
            redirect: {
                name : "enterprise-account-whole"
            },
            component: () => import('@/pages/enterprise/account/Index'),
            children: [
                {
                    path: 'account',
                    name: 'enterprise-account-whole',
                    meta: {
                        title: '企业账户管理-全部账户'
                    },
                    component: () => import('@/pages/enterprise/account/Account'),
                },
                {
                    path: 'ordinary',
                    name: 'enterprise-ordinary',
                    meta: {
                        title: '企业账户管理-普通账户'
                    },
                    component: () => import('@/pages/enterprise/account/Account'),
                },
                {
                    path: 'ban',
                    name: 'enterprise-ban',
                    meta: {
                        title: '企业账户管理-禁止账户'
                    },
                    component: () => import('@/pages/enterprise/account/Account'),
                }
            ]
        },
        {
            path: 'enterprise-account-detail/:id',
            name: 'enterprise-account-detail',
            meta: {
                title: '账户详情'
            },
            component: () => import('@/pages/enterprise/account/Detail'),
        }
    ]
    
}


// WEBPACK FOOTER //
// ./src/router/enterprise/account_enterprise/index.js